var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirewallBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4054",
    "data-name": "Group 4054",
    transform: "translate(-174 -1896)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(174 1896)",
    fill: "#24397a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4055",
    "data-name": "Group 4055",
    transform: "translate(-827 -20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2604",
    "data-name": "Group 2604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "verified_user-24px",
    transform: "translate(1017 1932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M0,0H48V48H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M21,1,3,9V21c0,11.1,7.68,21.48,18,24,10.32-2.52,18-12.9,18-24V9ZM35,21c0,9.04-5.96,17.38-14,19.86C12.96,38.38,7,30.04,7,21V11.6L21,5.38,35,11.6Z",
    transform: "translate(3 1)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "arrow_upward-24px_1_",
    "data-name": "arrow_upward-24px (1)",
    transform: "translate(1029 1944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M4,12l1.41,1.41L11,7.83V20h2V7.83l5.58,5.59L20,12,12,4Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirewallBg);
export default __webpack_public_path__ + "static/media/firewall_bg.9837fc2fc910451fa309849588474d9a.svg";
export { ForwardRef as ReactComponent };